import { Form } from 'antd';
import { useState } from 'react';
import ConditionSetModal from './ConditionSetModal';
import { Box, Stack, Typography } from '@mui/material';
import { PlusCircleOutlined } from '@ant-design/icons';
import ActionButton from 'components/button/ActionButton';
import FileViewIconButton from 'components/button/FileViewIconButton';
import useSolutionConditionHook from '../hooks/useSolutionConditionHook';

const ConditionConfiguration = ({ form, disabled }) => {
	const [id, setId] = useState(null);
	const [modalOpen, setModalOpen] = useState(false);
	const [parentField, setParentField] = useState(null);

	const {
		SLAList,
		editList,
		structure,
		timestamp,
		nameOption,
		mapInputType,
		prevIndexMap,
		dropDownLabel,
		controlListMap,
		setPrevIndexMap,
		finalPeopleOptions,
	} = useSolutionConditionHook({ form });

	console.log(form.getFieldValue('conditionPeopleSet'), 'conditionPeopleSet');

	return (
		<Box>
			<Form.Item noStyle name="conditionId" />
			<Form.Item noStyle name="taskActionTaken" />

			<Form.List name={['conditionPeopleSet']}>
				{(parentFields, parentOpt) => (
					<>
						<Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
							<Typography fontSize={14} fontWeight={500}>
								Condition Set
							</Typography>

							{parentFields?.length > 0 && (
								<ActionButton
									variantType="edit"
									label="Edit Condition"
									tooltip="Edit Condition"
									icon={<PlusCircleOutlined />}
									onClick={() => {
										setModalOpen(true);
									}}
								/>
							)}

							{!disabled && parentFields?.length === 0 && (
								<ActionButton
									label="Add New"
									variantType="add"
									tooltip="Add New"
									icon={<PlusCircleOutlined />}
									onClick={() => {
										setModalOpen(true);

										const filedId = parentFields?.length;

										// setId(filedId);
										setParentField({
											name: filedId,
											key: filedId,
											isListField: true,
											fieldKey: filedId,
										});

										const taskCode = form.getFieldValue(['solutionTaskCode']);

										if (editList && structure?.conditionPeopleSet?.[0]) {
											parentOpt.add(structure?.conditionPeopleSet[0]);

											setPrevIndexMap((prev) => ({
												...prev,
												[taskCode]: prev[taskCode] + 1,
											}));
										} else {
											parentOpt.add({
												lynApprovalConditions: [
													{
														key: undefined,
														operation: undefined,
														operand: undefined,
													},
												],
												lynApprovalPeopleSerial: [
													{
														flow: '1',
														peopleOf: undefined,
														value: undefined,
													},
												],
												lynApprovalSLA: {
													slaCode: undefined,
													duration: undefined,
													unit: undefined,
												},
											});
											setPrevIndexMap((prev) => ({
												...prev,
												[taskCode]: prev[taskCode] + 1,
											}));
										}
									}}
								/>
							)}
						</Stack>

						{/* {parentFields.map((parentField, key) => (
							<>
								<Box>
									<Stack direction="row" justifyContent="space-between" sx={{ mt: '16px' }} spacing={2}>
										<Typography>Condition {key + 1}</Typography>

										<Stack direction="row" spacing={2}>
											<FileViewIconButton
												onClick={() => {
													setId(key);
													setModalOpen(true);
													setParentField(parentField);
												}}
											/>
										</Stack>
									</Stack>
								</Box>
							</>
						))} */}

						{modalOpen && (
							<ConditionSetModal
								id={id}
								form={form}
								open={modalOpen}
								SLAList={SLAList}
								disabled={disabled}
								editList={editList}
								structure={structure}
								timestamp={timestamp}
								parentOpt={parentOpt}
								nameOption={nameOption}
								parentField={parentField}
								mapInputType={mapInputType}
								prevIndexMap={prevIndexMap}
								parentFields={parentFields}
								dropDownLabel={dropDownLabel}
								controlListMap={controlListMap}
								setPrevIndexMap={setPrevIndexMap}
								onClose={() => setModalOpen(false)}
								finalPeopleOptions={finalPeopleOptions}
								handleDelete={() => {
									parentOpt.remove(parentField.name);

									const taskCode = form.getFieldValue(['solutionTaskCode']);
									setPrevIndexMap((prev) => ({
										...prev,
										[taskCode]: prev[taskCode] - 1,
									}));

									setModalOpen(false);
								}}
							/>
						)}
					</>
				)}
			</Form.List>
		</Box>
	);
};

export default ConditionConfiguration;

// import { Form } from 'antd';
// import { useState } from 'react';
// import ConditionSetModal from './ConditionSetModal';
// import { Box, Stack, Typography } from '@mui/material';
// import { PlusCircleOutlined } from '@ant-design/icons';
// import ActionButton from 'components/button/ActionButton';
// import FileViewIconButton from 'components/button/FileViewIconButton';
// import useSolutionConditionHook from '../hooks/useSolutionConditionHook';

// const ConditionConfiguration = ({ form, disabled }) => {
// 	const [id, setId] = useState(null);
// 	const [modalOpen, setModalOpen] = useState(false);
// 	const [parentField, setParentField] = useState(null);

// 	const {
// 		SLAList,
// 		editList,
// 		structure,
// 		timestamp,
// 		nameOption,
// 		mapInputType,
// 		prevIndexMap,
// 		dropDownLabel,
// 		controlListMap,
// 		setPrevIndexMap,
// 		finalPeopleOptions,
// 	} = useSolutionConditionHook({ form });

// 	return (
// 		<Box>
// 			<Form.Item noStyle name="conditionId" />
// 			<Form.Item noStyle name="taskActionTaken" />

// 			<Form.List name={['conditionPeopleSet']}>
// 				{(parentFields, parentOpt) => (
// 					<>
// 						<Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
// 							<Typography fontSize={14} fontWeight={500}>
// 								Condition Set
// 							</Typography>

// 							{!disabled && (
// 								<ActionButton
// 									label="Add New"
// 									variantType="add"
// 									tooltip="Add New"
// 									icon={<PlusCircleOutlined />}
// 									onClick={() => {
// 										setModalOpen(true);

// 										const filedId = parentFields?.length;

// 										setId(filedId);
// 										setParentField({
// 											name: filedId,
// 											key: filedId,
// 											isListField: true,
// 											fieldKey: filedId,
// 										});

// 										const taskCode = form.getFieldValue(['solutionTaskCode']);

// 										if (editList && structure?.conditionPeopleSet?.[0]) {
// 											parentOpt.add(structure?.conditionPeopleSet[0]);

// 											setPrevIndexMap((prev) => ({
// 												...prev,
// 												[taskCode]: prev[taskCode] + 1,
// 											}));
// 										} else {
// 											parentOpt.add({
// 												lynApprovalConditions: [
// 													{
// 														key: undefined,
// 														operation: undefined,
// 														operand: undefined,
// 													},
// 												],
// 												lynApprovalPeopleSerial: [
// 													{
// 														flow: '1',
// 														peopleOf: undefined,
// 														value: undefined,
// 													},
// 												],
// 												lynApprovalSLA: {
// 													slaCode: undefined,
// 													duration: undefined,
// 													unit: undefined,
// 												},
// 											});
// 											setPrevIndexMap((prev) => ({
// 												...prev,
// 												[taskCode]: prev[taskCode] + 1,
// 											}));
// 										}
// 									}}
// 								/>
// 							)}
// 						</Stack>

// 						{/* {parentFields.map((parentField, key) => (
// 							<>
// 								<Box>
// 									<Stack direction="row" justifyContent="space-between" sx={{ mt: '16px' }} spacing={2}>
// 										<Typography>Condition {key + 1}</Typography>

// 										<Stack direction="row" spacing={2}>
// 											<FileViewIconButton
// 												onClick={() => {
// 													setId(key);
// 													setModalOpen(true);
// 													setParentField(parentField);
// 												}}
// 											/>
// 										</Stack>
// 									</Stack>
// 								</Box>
// 							</>
// 						))} */}

// 						{parentField && (
// 							<ConditionSetModal
// 								id={id}
// 								form={form}
// 								open={modalOpen}
// 								SLAList={SLAList}
// 								disabled={disabled}
// 								timestamp={timestamp}
// 								nameOption={nameOption}
// 								parentField={parentField}
// 								mapInputType={mapInputType}
// 								prevIndexMap={prevIndexMap}
// 								parentFields={parentFields}
// 								dropDownLabel={dropDownLabel}
// 								controlListMap={controlListMap}
// 								onClose={() => setModalOpen(false)}
// 								finalPeopleOptions={finalPeopleOptions}
// 								handleDelete={() => {
// 									parentOpt.remove(parentField.name);

// 									const taskCode = form.getFieldValue(['solutionTaskCode']);
// 									setPrevIndexMap((prev) => ({
// 										...prev,
// 										[taskCode]: prev[taskCode] - 1,
// 									}));

// 									setModalOpen(false);
// 								}}
// 							/>
// 						)}
// 					</>
// 				)}
// 			</Form.List>
// 		</Box>
// 	);
// };

// export default ConditionConfiguration;
